<template>
    <div class="row">
        <!-- HIDE FROM UI -->
        <!-- <div class="col-12">
            <div class="weekly-sheets-page--header">
                <div class="weekly-sheets-page--header-item">
                    <h1 class="weekly-sheets-page--header-item-title">{{makeHoursReadable(header_stats.total_hours)}} hrs</h1>
                    <h6 class="weekly-sheets-page--header-item-subtitle">Total hours worked</h6>
                </div>
                <div class="weekly-sheets-page--header-item">
                    <h1 class="weekly-sheets-page--header-item-title">{{makeHoursReadable(header_stats.avg_week)}} hrs</h1>
                    <h6 class="weekly-sheets-page--header-item-subtitle">Avg Weekly hours worked per operative</h6>
                </div>
                <div class="weekly-sheets-page--header-item">
                    <h1 class="weekly-sheets-page--header-item-title">{{makeHoursReadable(header_stats.avg_per_day)}} hrs</h1>
                    <h6 class="weekly-sheets-page--header-item-subtitle">Avg Hours worked per operative</h6>
                </div>
            </div>
        </div> -->

        <div v-if="all_weeks.length > 0" id="week-acordion" class="col-12">
            <collapsable
                v-for="(month_group, index) in all_weeks"
                :key="index"
                accordion="#week-acordion"
            >
                <template slot="header_content">
                    <div>
                        <h5>{{month_group.month}}</h5>
                        <h6>{{getLastSubmittedForMonth(month_group)}}</h6>
                    </div>
                </template>

                <template slot="content">
                    <collapsable
                        class="px-0 mb-2"
						v-bind:class="week.status ? 'invalid' : ''"
                        v-for="week in month_group.data"
                        :key="week.index"
                        v-if="week.form_submission"
                    >
                        <template slot="header_content">
                            <div class="w-100 d-flex justify-content-between flex-wrap">
                                <div>
                                    <h6 class="text-primary">Week {{week.week}}</h6>
                                    <h6 v-if="week.form_submission">Submitted at {{week.form_submission.submitted_formatted}}</h6>
                                    <h6 v-else> - </h6>

									<h6 v-if="week.form_submission && week.form_submission.status" class="text-danger">
										This week sheet was made invalid by a newer version.
									</h6>
                                </div>
                                <div class="my-auto" v-if="week.submitted_user">
                                    <div class="badge badge--sm badge--light-grey">
                                        {{week.submitted_user.full_name}}
                                    </div>
                                </div>
                            </div>
                        </template>

                        <template slot="content">
                            <div class="weekly-sheets-page--calendar">
                                <div class="weekly-sheets-page--calendar-header weekly-sheets-page--calendar-row">
                                    <div class="weekly-sheets-page--calendar-row-item week">{{week.week_date_formatted}}</div>
                                    <div class="weekly-sheets-page--calendar-row-item">Mon</div>
                                    <div class="weekly-sheets-page--calendar-row-item">Tue</div>
                                    <div class="weekly-sheets-page--calendar-row-item">Wed</div>
                                    <div class="weekly-sheets-page--calendar-row-item">Thu</div>
                                    <div class="weekly-sheets-page--calendar-row-item">Fri</div>
                                    <div class="weekly-sheets-page--calendar-row-item">Sat</div>
                                    <div class="weekly-sheets-page--calendar-row-item">Sun</div>
                                    <div class="weekly-sheets-page--calendar-row-item hours">Total Hrs</div>
                                </div>

                                <div v-for="record in week.records" class="weekly-sheets-page--calendar-row">
                                    <div class="weekly-sheets-page--calendar-row-item user people-list--item-title">
                                        <h6 class="people-list--item-title-name">{{record.user.full_name}}</h6>
                                        <h6 class="people-list--item-title-email">{{record.user.email}}</h6>
                                    </div>
                                    <div class="weekly-sheets-page--calendar-row-item">
                                        <div class="weekly-sheets-page--calendar-row-item-sm">Mon</div>
                                        <div class="weekly-sheets-page--calendar-row-item-val">{{makeHoursReadable(record.monday)}}</div>
                                    </div>
                                    <div class="weekly-sheets-page--calendar-row-item">
                                        <div class="weekly-sheets-page--calendar-row-item-sm">Tue</div>
                                        <div class="weekly-sheets-page--calendar-row-item-val">{{makeHoursReadable(record.tuesday)}}</div>
                                    </div>
                                    <div class="weekly-sheets-page--calendar-row-item">
                                        <div class="weekly-sheets-page--calendar-row-item-sm">Wed</div>
                                        <div class="weekly-sheets-page--calendar-row-item-val">{{makeHoursReadable(record.wednesday)}}</div>
                                    </div>
                                    <div class="weekly-sheets-page--calendar-row-item">
                                        <div class="weekly-sheets-page--calendar-row-item-sm">Thu</div>
                                        <div class="weekly-sheets-page--calendar-row-item-val">{{makeHoursReadable(record.thursday)}}</div>
                                    </div>
                                    <div class="weekly-sheets-page--calendar-row-item">
                                        <div class="weekly-sheets-page--calendar-row-item-sm">Fri</div>
                                        <div class="weekly-sheets-page--calendar-row-item-val">{{makeHoursReadable(record.friday)}}</div>
                                    </div>
                                    <div class="weekly-sheets-page--calendar-row-item">
                                        <div class="weekly-sheets-page--calendar-row-item-sm">Sat</div>
                                        <div class="weekly-sheets-page--calendar-row-item-val">{{makeHoursReadable(record.saturday)}}</div>
                                    </div>
                                    <div class="weekly-sheets-page--calendar-row-item">
                                        <div class="weekly-sheets-page--calendar-row-item-sm">Sun</div>
                                        <div class="weekly-sheets-page--calendar-row-item-val">{{makeHoursReadable(record.sunday)}}</div>
                                    </div>
                                    <div class="weekly-sheets-page--calendar-row-item hours">
                                        <div class="weekly-sheets-page--calendar-row-item-sm">Total Hrs</div>
                                        <div class="weekly-sheets-page--calendar-row-item-val">{{makeHoursReadable(sumHours(record))}}</div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </collapsable>

                </template>
            </collapsable>
        </div>
        <div v-else class="col-12">
            <div class="flex-table text-center">
                <h5 class="m-4 mx-auto text-dark">No timesheets found.</h5>
            </div>
        </div>
    </div>
</template>

<script>
	import Collapsable from "../ListComponent/Collapsable";
    export default {
		name: "WeeklySheetsPage",
        components: {Collapsable},
        props: [
        	'job',
            'header_stats',
            'all_weeks',

            'show_url'
        ],

        methods: {
            getLastSubmittedForMonth(month_group){
			    let submitted_last_date = 0;
			    let submitted_formatted = '-';

                month_group.data.forEach(function (week){
                    if (week.form_submission){
                        if (Date.parse(week.form_submission.submitted_at) > submitted_last_date){
                            submitted_last_date = Date.parse(week.form_submission.submitted_at);
                            submitted_formatted = week.form_submission.submitted_formatted;
                        }
                    }
                });

                return submitted_formatted;
            },


            makeHoursReadable(hours){
                const point_hours = (hours % 1);
                const minutes = Math.round(point_hours * 60);
                const formatted_hours = Math.floor(hours).toLocaleString('en-GB');

                return formatted_hours + ':' + (minutes > 9 ? minutes : '0' + minutes);
            },
            sumHours(record){
                return record.monday +
                record.tuesday +
                record.wednesday +
                record.thursday +
                record.friday +
                record.saturday +
                record.sunday;
            }
        }
	}
</script>
